import axios from 'axios'
import config from "../config/constants";
import { toastr } from 'react-redux-toastr';
import info from "../config/messages";
import { getLoggedUser} from "./index";

export const LOAD_USERS = "LOAD_USERS";
export const CREATE_USERS = "CREATE_USERS";
export const UPDATE_USERS = "UPDATE_USERS";
export const DELETE_USERS = "DELETE_USERS";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const ERROR = "ERROR";

export const loadUsers = (props, scope) => {
    return (dispatch, getState) => {
        axios.get(config.PROJECT_DASHBOARD_API_URL + 'aiservice/users?size=' + config.DEFAULT_PAGE_SIZE).then(({ data }) => {
            dispatch({
                type: LOAD_USERS,
                payload: data
            });
        }).catch(function (error) {
            dispatch({
                type: ERROR,
                payload: { type: "danger", message: "Invalid Credentials" }
            });
        });
    }
}


export const createUsers = (props, scope) => {

    if (props.sub) {
        return (dispatch, getState) => {
            axios.put(config.PROJECT_DASHBOARD_API_URL + 'aiservice/users', props).then(({ data }) => {
                dispatch({
                    type: UPDATE_USERS,
                    payload: data
                });
                dispatch(getLoggedUser());
                toastr.success(info.Success.User.update);
            }).catch(function (error) {
                toastr.error(info.Failed.User.update, error.response.data.error);
            });
        }
    } else {
        return (dispatch, getState) => {
            axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/users', props).then(({ data }) => {
                dispatch({
                    type: CREATE_USERS,
                    payload: data
                });
                toastr.success(info.Success.User.create);
            }).catch(function (error) {
                console.log("error", error.response);
                toastr.error(info.Failed.User.create, error.response.data.error);
            });
        }
    }
}

export const deleteUser = (props, scope) => {
    return (dispatch, getState) => {
        axios.delete(config.PROJECT_DASHBOARD_API_URL + 'aiservice/users/' + props.username).then(({ data }) => {
            dispatch({
                type: DELETE_USERS,
                payload: props.username
            });
            toastr.success(info.Success.User.delete);
        }).catch(function (error) {
            toastr.error(info.Failed.User.delete, error.response.data.error);
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/user_management.js